import { MouseEventHandler } from 'react';
import { Image as ImageType } from '../../commonTypes/image';

export enum ShareType {
  EMAIL = 'email',
  FACEBOOK = 'facebook',
  TWITTER = 'twitter',
  WHATSAPP = 'whatsApp',
  LINKEDIN = 'linkedIn',
  PINTEREST = 'pinterest',
}

export type ShareLogo = {
  shareType: ShareType;
  image: ImageType;
  onClick?: MouseEventHandler;
};

export type SharingLink = {
  url: string;
  title?: string;
  description?: string;
  image?: string;
};
